import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home'
import ConfirmaInscricao from '../views/confirmainscricao'
import ConfirmaTerms from '../views/confirmaterms'
import TestForm from '../views/test-form.vue'

const routes = [
  {
    path: '/',
    name: 'inicio',
    component: Home
  },
  {
    path: '/confirmacao-inscricao',
    component: ConfirmaInscricao
  },
  {
    path: '/confirmacao-terms',
    component: ConfirmaTerms
  },
  {
    path: '/teste-formulario',
    name: 'test-form',
    component: TestForm
  },
  {
    path: '/acao-retorno/:token',
    name: 'follow-up-form',
    component: Home
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
